module.exports = __webpack_public_path__ + "img/67_2.17de3995.png";